import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="text-sm text-gray-500">
            &copy; {new Date().getFullYear()} Scribedo. All rights reserved.
          </div>
          <div className="flex space-x-6">
            <Link 
              to="/faq" 
              className="text-sm text-gray-500 hover:text-gray-900 transition-colors"
            >
              FAQ
            </Link>
            <Link 
              to="/privacy" 
              className="text-sm text-gray-500 hover:text-gray-900 transition-colors"
            >
              Privacy Policy
            </Link>
            <a 
              href="mailto:support@scribedo.com" 
              className="text-sm text-gray-500 hover:text-gray-900 transition-colors"
            >
              Support
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 